import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const AbsenceReasonsFilters = ({
  searchTerm,
  setSearchTerm,
  filterCategory,
  setFilterCategory,
  filterPaid,
  setFilterPaid,
  filterActive,
  setFilterActive,
  categories,
  filteredReasons,
}) => {
  const { t } = useTranslation();
  const hasActiveFilters =
    searchTerm || filterCategory !== 'all' || filterPaid !== 'all' || filterActive !== 'all';

  const resetAll = () => {
    setSearchTerm('');
    setFilterCategory('all');
    setFilterPaid('all');
    setFilterActive('all');
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('absenceReasons.filters.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder={t('common.search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9"
            />
          </div>

          <Select value={filterCategory} onValueChange={setFilterCategory}>
            <SelectTrigger><SelectValue placeholder={t('absenceReasons.filters.allCategories')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('absenceReasons.filters.allCategories')}</SelectItem>
              {categories.map((cat) => (
                <SelectItem key={cat.value} value={cat.value}>
                  {cat.icon} {cat.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={filterPaid} onValueChange={setFilterPaid}>
            <SelectTrigger><SelectValue placeholder={t('absenceReasons.filters.paidUnpaid')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('common.all')}</SelectItem>
              <SelectItem value="true">{t('common.paid')}</SelectItem>
              <SelectItem value="false">{t('common.unpaid')}</SelectItem>
            </SelectContent>
          </Select>

          <Select value={filterActive} onValueChange={setFilterActive}>
            <SelectTrigger><SelectValue placeholder={t('absenceReasons.filters.activeInactive')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('common.all')}</SelectItem>
              <SelectItem value="true">{t('common.active')}</SelectItem>
              <SelectItem value="false">{t('common.inactive')}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {hasActiveFilters && (
          <div className="mt-4 flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={resetAll}>
              <X className="mr-2 h-4 w-4" />
              {t('absenceReasons.filters.reset')}
            </Button>
            <span className="text-sm text-muted-foreground">
              {t('absenceReasons.filters.resultsFound', { count: filteredReasons.length })}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AbsenceReasonsFilters;
